<template>
  <div>

  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  created() {
    let datas = {
      code: this.$route.query.code,
      system: '1'
    }
    this.$api.wxLogin(datas).then(res => {
      if (res.code == 0) {
        localStorage.setItem("japan_access_token", res.data.access_token);
        document.cookie = `japan_access_token=${res.data.access_token} ${res.data.userInfo.id}`;
        localStorage.setItem(
          "japanUserRoleInfo",
          JSON.stringify(res.data.userInfo)
        );
        localStorage.setItem(
          "japanUserRoleStatus",
          res.data.userInfo.role[0].work_type
        );
        this.$store.dispatch("userAuth");
        this.$store.dispatch("getMenu");
        this.$router.replace("/homePage");
      } else {
        // 登录失败哦
        this.$router.replace("/login");
        this.$message.error(res.msg)
      }


    })
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped></style>